import React from 'react';

import { BadgePropsType } from './types';

import './styles.scss';

export default ({ past, live, tooltip, tooltipData, margin, children, style }: BadgePropsType) => {
  return (
    <div
      className={`badge ${past ? 'badge-past' : ''} ${live ? 'badge-live' : ''} ${tooltip ? 'badge-tooltip' : ''}
      ${tooltipData ? 'badge-tooltip-data' : ''} ${margin ? 'badge-tooltip-data-none' : ''}`}
      style={style}
    >
      {children}
    </div>
  );
};
